export default function (fileUri: string): string {
  const config = useRuntimeConfig()
  return `${config.public.serverUrl}${fileUri}`
}
